import React, { useEffect, useState } from 'react'
import api from "../../services/api"
import { useNavigate } from 'react-router'
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { formatDate, formatDateWithTime, formatDateYYYYMMDD, ISODateString } from "../../utils/dateFormat";
import Modal from 'react-bootstrap/Modal';
import { roles } from '../../utils/constants';
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';
import async from "async";


function CreativewiseReport(object) {
  const campaign_id = object.campaign_id
  const camp = object.camp
  const x_value = camp.x_value
  const navigate = useNavigate()
  const [data, setData] = useState([])
  const [loader, setLoader] = useState(false);
  const [creatloader, setcreatLoader] = useState(false);


  const [totalPages, setTotalPages] = useState(0);
  const [creattotalPages, setcreatTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [creatcurrentPage, setcreatCurrentPage] = useState(0);

  const [creative_Names, setCreative_Names] = useState([])
  const [formshow, setFormshow] = useState(false)
  const [creativedetails, setcreativedetails] = useState({})
  const [seletedcreative, setSelectedcreative] = useState(0)

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    getdata(campaign_id, event.selected)
  };
  const creathandlePageClick = (event) => {
    setcreatCurrentPage(event.selected);
    view(seletedcreative, event.selected)
  };
  const view = async (_id, page = 0) => {
    setcreatLoader(true);
    setFormshow(true)
    try {
      let res = await api({
        url: '/reports/daywisereports',
        method: 'POST',
        responseType: 'json',
        data: {
          creativeid: _id,
          campid: campaign_id,
          grouped: camp.grouped,
          x_value,
          page,
          action: "creativedate",
          limit: config.PER_PAGE,
        }
      });
      if (res.code === 200) {
        setcreativedetails(res.data.totalres);
        setcreatTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
      }
      setcreatLoader(false);

    } catch (error) {
      console.error(error);
      if (error.response.status === 401)
        navigate("/")
    }

  }

  async function fetchCreativeNames(item) {
    try {
      const item_res = await api({
        url: "/user/campaign_creation/creative_Names",
        method: "POST",
        responseType: 'json',
        data: { ids: item.creative_ids, campaign_id: item.campaign_id, type: item.type }
      });
      return item_res.data;
    } catch (err) {
      console.error("Error fetching creative names:", err);
      throw err; // Rethrow the error to handle it later if needed
    }
  }

  const getCreativeNames = async (ids, campaign_id, type, grouped) => {
    try {
      let res = await api({
        url: "/user/campaign_creation/creative_Names",
        method: "POST",
        responseType: 'json',
        data: { ids, campaign_id, type }
    })
    if(grouped){
        let group_creative_details_data = await api({
            url: "/user/campaign_creation/getGroupCampCreatives",
            method: "POST",
            responseType: 'json',
            data: {campaign_id}
        })
        let temp_creatives = []
        temp_creatives = temp_creatives.concat(res.data)
        const promises = group_creative_details_data?.data?.map(fetchCreativeNames);
        try {
          const results = await Promise.all(promises);
          temp_creatives = temp_creatives.concat(results.flat()); // Flatten the array of results
          setCreative_Names(temp_creatives);
        } catch (err) {
          console.error("Error processing creative names:", err);
        }
      }
      else {
        setTimeout(() => setCreative_Names(res.data), 0)
      }

    } catch (error) {
      console.log(error)
      if (error.response.status === 401)
        navigate("/")
    }
  }
  const getdata = async (campid = campaign_id, page = 0) => {
    setLoader(true);
    try {
      let res = await api({
        url: '/reports/daywisereports',
        method: 'POST',
        responseType: 'json',
        data: {
          campid,
          grouped: camp.grouped,
          x_value,
          page,
          action: "creativewise",
          limit: config.PER_PAGE,
        }
      });
      if (res.code === 200) {
        setData(res.data.totalres);
        setTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
      }
      setLoader(false);

    } catch (error) {
      console.error(error);
      if (error.response.status === 401)
        navigate("/")
    }

  }
  useEffect(() => {
    getdata()
    getCreativeNames(camp.creative_ids, camp.campaign_id, camp.type, camp.grouped)
  }, [])
  function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  }

  return (
    <div>
      <div className="overflow-x-auto">
        <table className='table table-bordered'>
          <thead>
            <tr>
              {/* Campaign Creation */}
              {/* <th>Campaign Id</th> */}
              <th>Creative</th>
              {localStorage.getItem('role') === roles.advertiser ? <th>Audience Viewed</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Impressions</th> : <th>Impressions</th>}
              {localStorage.getItem('role') === roles.advertiser ? <th>Audience Engaged</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Clicks</th> : <th>Clicks</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>Advertiser Impressions</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>Advertiser Clicks</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>CTR(%)</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>ECPM</th>}
              <th>Spent</th>
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th scope='col'>Advertiser Spent</th>}
              {localStorage.getItem("role") === roles.ops && <th>E Impressions</th>}
              {localStorage.getItem("role") === roles.ops && <th>E Adv Impressions</th>}
              {localStorage.getItem("role") === roles.ops && <th>Actual Clicks</th>}
              {localStorage.getItem("role") === roles.ops && <th>Shares</th>}
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item._id} className="group/details hover:bg-slate-100">
                    <td style={{ color: "blue", cursor: "pointer" }} onClick={() => { view(item._id); setSelectedcreative(item._id) }}>{creative_Names?.length ? creative_Names.filter((obj) => (obj.creative_id === item._id || item._id === parseInt(obj.dfp_creative_id)))[0]?.name : ""}</td>
                    <td>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  ? item.total_imp : parseInt(item.adv_total_imp)}</td>
                    <td>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? item.total_click : parseInt(item.adv_total_click)}</td>
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <td >{parseInt(item.adv_total_imp)}</td>}
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <td >{parseInt(item.adv_total_click)}</td>}
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <td title={item.total_click > 0 && item.total_imp > 0 ? (item.total_click / item.total_imp) * 100 : 0}>{item.total_click > 0 && item.total_imp > 0 ? ((item.total_click / item.total_imp) * 100).toFixed(2) : 0}</td>}
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <td title={camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? ((camp.cpc_price * item.total_click) / item.total_imp) * 1000 : camp.campaign_type === "CPM" && item.total_imp > 0 ? camp.cpm : camp.campaign_type === "CPD" ? camp.cpd : "0"}>{camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? (((camp.cpc_price * item.total_click) / (item.total_imp)) * 1000).toFixed(2) : camp.campaign_type === "CPM" && item.total_imp > 0 ? ((((camp.cpm * item.total_imp) / 1000) / item.total_imp) * 1000).toFixed(2) : camp.campaign_type === "CPD" ? camp.cpd : "0"}</td>}
                    <td title={(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.total_imp) / 1000 : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.adv_total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.adv_total_imp) / 1000 : 0) : "0")}>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.total_imp) / 1000).toFixed(2) : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <td title={(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.adv_total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.adv_total_imp) / 1000 : 0) : "0")}>{(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.encrypt_imp > 0 ? item?.encrypt_imp : 0)}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.encrypt_adv_imp > 0 ? item?.encrypt_adv_imp : 0)}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.actual_clicks > 0 ? item?.actual_clicks : 0)}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.shares > 0 ? item?.shares : 0)}</td>}
                  </tr>

                )
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      {totalPages > 1 && <Paginator
        pageCount={totalPages}
        handlePageClick={handlePageClick}
        forcePage={currentPage}
      />
      }
      {/* <Modal
        show={formshow}
        backdrop="static"
        keyboard={false}
        onHide={() => { setFormshow(false); setcreativedetails({});setSelectedcreative(0);setcreatCurrentPage(0)}}
        aria-labelledby="example-modal-sizes-title-sm">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            {creative_Names.filter((obj)=>(obj.creative_id === seletedcreative || seletedcreative === parseInt(obj.dfp_creative_id)))[0]?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="overflow-x-auto mb-4">
        <table className='table-base'>
          <thead>
            <tr> */}
      {/* Campaign Creation */}
      {/* <th>Campaign Id</th> */}
      {/* <th>Date</th>
              <th>Impressions</th>
              <th>Clicks</th>
              {localStorage.getItem("role") !== roles.advertiser && <th>Advertiser Impressions</th>}
              {localStorage.getItem("role") !== roles.advertiser && <th>Advertiser Clicks</th>}
              {localStorage.getItem("role") !== roles.advertiser && <th>CTR(%)</th>}
              {localStorage.getItem("role") !== roles.advertiser && <th>ECPM</th>}
              <th>Spent</th>
              {localStorage.getItem("role") !== roles.advertiser && <th scope='col'>Advertiser Spent</th>}
            </tr>
          </thead>
          {creativedetails?.length && !creatloader ? (
            <tbody>
              {creativedetails?.map((item, index) => {
                return (
                  <tr key={item._id.date} >
                    <td >{formatDate(item._id.date)}</td>
                    <td>{localStorage.getItem("role") !== roles.advertiser ? item.total_imp : parseInt(item.adv_total_imp)}</td>
                    <td>{localStorage.getItem("role") !== roles.advertiser ? item.total_click : parseInt(item.adv_total_click)}</td>
                    {localStorage.getItem("role") !== roles.advertiser && <td >{ parseInt(item.adv_total_imp)}</td>}
                    {localStorage.getItem("role") !== roles.advertiser && <td >{ parseInt(item.adv_total_click)}</td>}
                    {localStorage.getItem("role") !== roles.advertiser && <td>{item.total_click > 0 && item.total_imp > 0 ? ((item.total_click / item.total_imp)*100).toFixed(2) : 0}</td>}
                    {localStorage.getItem("role") !== roles.advertiser && <td>{camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? (((camp.cpc_price * item.total_click) / (item.total_imp)) * 1000).toFixed(2) : camp.campaign_type === "CPM" && item.total_imp > 0 ? ((((camp.cpm * item.total_imp) / 1000) / item.total_imp) * 1000).toFixed(2) : camp.campaign_type === "CPD" ? camp.cpd : "0"}</td>}
                    <td>{localStorage.getItem("role") !== roles.advertiser ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.total_imp) / 1000).toFixed(2) : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>
                    {localStorage.getItem("role") !== roles.advertiser && <td>{(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>}
                  </tr>

                )
              })}
            </tbody>
          ) : !creativedetails?.length && !creatloader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      <div>
        {creattotalPages > 1 && <Paginator
          pageCount={creattotalPages}
          handlePageClick={creathandlePageClick}
          forcePage={creatcurrentPage} />}
      </div>
        </Modal.Body>
      </Modal> */}

      <SlDrawer label={creative_Names?.length ? creative_Names.filter((obj) => (obj.creative_id === seletedcreative || seletedcreative === parseInt(obj.dfp_creative_id)))[0]?.name : "No data found"} open={formshow} onSlRequestClose={handleRequestClose} onSlAfterHide={() => { setFormshow(false); setcreativedetails({}); setSelectedcreative(0); setcreatCurrentPage(0) }} style={{ '--size': '75vw' }}>
        <div className="overflow-x-auto mb-4">
          <table className='table table-bordered'>
            <thead>
              <tr>
                {/* Campaign Creation */}
                {/* <th>Campaign Id</th> */}
                <th>Date</th>
                {localStorage.getItem('role') === roles.advertiser ? <th>Audience Viewed</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Impressions</th> : <th>Impressions</th>}
                {localStorage.getItem('role') === roles.advertiser ? <th>Audience Engaged</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Clicks</th> : <th>Clicks</th>}
                {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>Advertiser Impressions</th>}
                {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>Advertiser Clicks</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>CTR(%)</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th>ECPM</th>}
                <th>Spent</th>
                {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson )  && <th scope='col'>Advertiser Spent</th>}
                {localStorage.getItem("role") === roles.ops && <th>E Impressions</th>}
                {localStorage.getItem("role") === roles.ops && <th>E Adv Impressions</th>}
                {localStorage.getItem("role") === roles.ops && <th>Actual Clicks</th>}
                {localStorage.getItem("role") === roles.ops && <th>Shares</th>}
              </tr>
            </thead>
            {creativedetails?.length && !creatloader ? (
              <tbody>
                {creativedetails?.map((item, index) => {
                  return (
                    <tr key={item._id.date} >
                      <td >{formatDate(item._id.date)}</td>
                      <td>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? item.total_imp : parseInt(item.adv_total_imp)}</td>
                      <td>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? item.total_click : parseInt(item.adv_total_click)}</td>
                      {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td >{parseInt(item.adv_total_imp)}</td>}
                      {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td >{parseInt(item.adv_total_click)}</td>}
                      {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td title={item.total_click > 0 && item.total_imp > 0 ? (item.total_click / item.total_imp) * 100 : 0}>{item.total_click > 0 && item.total_imp > 0 ? ((item.total_click / item.total_imp) * 100).toFixed(2) : 0}</td>}
                      {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td title={camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? ((camp.cpc_price * item.total_click) / item.total_imp) * 1000 : camp.campaign_type === "CPM" && item.total_imp > 0 ? camp.cpm : camp.campaign_type === "CPD" ? camp.cpd : "0"}>{camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? (((camp.cpc_price * item.total_click) / (item.total_imp)) * 1000).toFixed(2) : camp.campaign_type === "CPM" && item.total_imp > 0 ? ((((camp.cpm * item.total_imp) / 1000) / item.total_imp) * 1000).toFixed(2) : camp.campaign_type === "CPD" ? camp.cpd : "0"}</td>}
                      <td title={(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.total_imp) / 1000 : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.adv_total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.adv_total_imp) / 1000 : 0) : "0")}>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.total_imp) / 1000).toFixed(2) : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>
                      {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td title={(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.adv_total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.adv_total_imp) / 1000 : 0) : "0")}>{(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>}
                      {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.encrypt_imp > 0 ? item?.encrypt_imp : 0)}</td>}
                      {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.encrypt_adv_imp > 0 ? item?.encrypt_adv_imp : 0)}</td>}
                      {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.actual_clicks > 0 ? item?.actual_clicks : 0)}</td>}
                      {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.shares > 0 ? item?.shares : 0)}</td>}
                    </tr>

                  )
                })}
              </tbody>
            ) : !creativedetails?.length && !creatloader ? (
              <NoDataFound colspan="15" />
            ) : (
              <TableLoader colspan="15" />
            )}
          </table>
        </div>
        <div>
          {creattotalPages > 1 && <Paginator
            pageCount={creattotalPages}
            handlePageClick={creathandlePageClick}
            forcePage={creatcurrentPage} />}
        </div>
      </SlDrawer>

    </div>
  )
}

export default CreativewiseReport
